import { OptimusConfigType } from '@openng/optimus-ui/config';
import { padspinPrimengPreset } from './padspin-primeng-preset';
import { PRIMENG_DARK_MODE_CSS_CLASS } from './primeng-dark-mode-toggler/padspin-primeng-dark-mode-selector';

export const padspinPrimengConfig: OptimusConfigType = {
  theme: {
    preset: padspinPrimengPreset,
    options: {
      darkModeSelector: `.${PRIMENG_DARK_MODE_CSS_CLASS}`,
    },
  },
};
